import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import Utils from '@/common/utils'

var ls = new SecureLS({ encodingType: "base64", isCompression: true });
Vue.use(Vuex)


const getDefaultState = () => ({
  loading: false,
  isUseASAM: false,


      isUseLetters:false,
      isUseMars:false,
      isUseDrugInboxFill:false,
      isUseDrugInboxAllergies:false,
      isUseDrugInboxFormularyStatus:false,
      isUseDrugInboxDrugInfo:false,
      isUseDrugInboxPatientInfo:false,
      isUseDrugInboxPharmacyNotes:false,
      isUseDrugInboxPrescription:false,
      isUseDrugInboxPrintMedLabel:false,
      isUseDrugInboxPrintMedicationHistory:false,
      isUseDrugInboxReturnedItems:false,
      isUseDrugInboxSetToChargeable:false,
      isUseDrugInboxSetToPending:false,
      isUseDrugInboxSetToUnableToFill:false,
      isUseDrugInboxSetToValid:false,
      isUseDrugInboxUndoFillOrder:false,
      isUseDrugInboxUndoSetToChargeable:false,
      isUseDrugInboxUndoSetToPending:false,
      isUseDrugInboxUndoValidated:false,

      isUsePatientInfo: false,      
      isUsePatientInsurance: false,
      isUsePatientDocument: false,
      isUsePatientContact: false,
      isUseClinicalNotes: false,
      isUseVitalSign: false,
      isUsePatientAllergies: false,
      isUsePatientAdmission:false,
      isUseChartReview:false,
      isUseTransfer:false,
      isUseMedications:false,
      isUseDischarge:false,
      isUsePatientDiagnosis:false,
      isUseDailyNotes:false,
      isUseLogNotes:false,
      isUsepharmacyPatientNewCrop:false,
      isUseCompleteDraft:false,
      isUseSchedulerClinical:false,
      isAppointments:false,
      isUseTreatmentPlanClinical:false,
      isEPrescribingClinical:false,
      isUsePatientSpecialPr: false,
      isUsePatientMarsAlert: false,
      isUsePatientAlerts: false,
      isUsePatientActivities: false,
      isUsePatientClaims:false,
      isPhysiciansOrder:false,


      isLettersEHRReadOnly:false,
      isDrugInboxFillEHRReadOnly: false,
      isDrugInboxAllergiesEHRReadOnly: false,
      isDrugInboxFormularyStatusEHRReadOnly: false,
      isDrugInboxDrugInfoEHRReadOnly: false,
      isDrugInboxPatientInfoEHRReadOnly: false,
      isDrugInboxPharmacyNotesEHRReadOnly: false,
      isDrugInboxPrescriptionEHRReadOnly: false,
      isDrugInboxPrintMedLabelEHRReadOnly: false,
      isDrugInboxPrintMedicationHistoryEHRReadOnly: false,
      isDrugInboxReturnedItemsEHRReadOnly: false,
      isDrugInboxSetToChargeableEHRReadOnly: false,
      isDrugInboxSetToPendingEHRReadOnly: false,
      isDrugInboxSetToUnableToFillEHRReadOnly: false,
      isDrugInboxSetToValidEHRReadOnly: false,
      isDrugInboxUndoFillOderEHRReadOnly: false,
      isDrugInboxUndoSetToChargeableEHRReadOnly: false,
      isDrugInboxUndoSetToPendingEHRReadOnly: false,
      isDrugInboxUndoValidatedEHRReadOnly: false,

      isASAMEHRReadOnly: false,
      isPatientInfoEHRReadOnly: false,
      isPatientInsuranceEHRReadOnly: false,
      isPatientContactsEHRReadOnly: false,
      isClinicalNotesEHRReadOnly: false,
      isVitalSignEHRReadOnly: false,
      isPatientAllergiesEHRReadOnly: false,
      isPatientAdmissionEHRReadOnly: false,
      isClinicalTransferEHRReadOnly:false,
      isClinicalMedicationsEHRReadOnly:false,
      isClinicalDischargeEHRReadOnly:false,
      isPatientDiagnosisEHRReadOnly:false,
      isDailyNotesEHRReadOnly:false,
      isPatientDocumentEHRReadOnly:false,
      isLogNotesEHRReadOnly:false,
      isSchedulerClinicalEHRReadOnly:false,
      isAppointmentsEHRReadOnly:false,
      isTreatmentPlanClinicalEHRReadOnly:false,
      isEPrescribingClinicalEHRReadOnly:false,
      isMarsEHRReadOnly:false,
      isTarsEHRReadOnly:false,
      isPatientSpecialPrEHRReadOnly:false,
      isPatientMarsAlertEHRReadOnly:false,
      isPatientAlertsEHRReadOnly:false,
      isPatientActivitiesEHRReadOnly:false,
      isPatientClaimsEHRReadOnly:false,
      isPhysiciansOrderEHRReadOnly:false,
      alreadyWrotePassword:false,
      alreadyWrotePasswordNotes:false,
      alreadyWrotePasswordCosignerNotes:'',
      alreadyWrotePasswordTars:false,

      RegionList:[],
      ethnicityList: [],
      ethnicitywasloaded:false,
      countrywasloaded:false,
      regionwasloaded:false,
      areawasloaded:false,
      citieswasloaded:false,
      mdCountrieswasloaded:false,
      genderList: [],
      branchlocationsList:[],
      genderwasloaded:false,
      branchlocationwasloaded:false,
      raceList: [],
      racewasloaded:false,      
      eyeColorList: [],
      eyeColorwasloaded:false,
      hairColorList: [],
      hairColorwasloaded:false,
      commPreferenceList:[],
      commPreferencewasloaded:false,
      familyIncomeList: [],
      familyIncomewasloaded:false,
      personalIncomeList: [],
      personalIncomewasloaded:false,
      majorLanguageList: [],
      majorLanguagewasloaded:false,
      majorLanguageAbilityList: [],
      majorLanguageAbilitywasloaded:false,
      majorReligionList: [],
      majorReligionwasloaded:false,
      disabilityList: [],
      disabilitywasloaded:false,
      legalStatusList: [],
      legalStatuswasloaded:false,
      educationStatusList: [],
      educationStatuswasloaded:false,

      CountryList:[],
      AreaList:[],
      CitiesList:[],
      MdCountriesList:[],

      ProvidersList:[],
      reasonDataSource:[],

      clinicalDashboardProgramsSelected:[],
      itemListGroupNotes:[],
      itemListCNContainer:[],

      sourceList:[],
      sourcewasloaded:false,
      classList:[],
      classwasloaded:false,
      typeList:[],  
      typewasloaded:false, 
      vocationalEffortList:[],
      vocationalEffortwasloaded:false, 
      vocationalCategoryList:[],
      vocationalCategorywasloaded:false,
      assessmentList:[],
      assessmentwasloaded:false,
      livingWithList:[],   
      livingWithwasloaded:false,
      referralsList:[],
      referralswasloaded:false,
      fromList:[],
      fromwasloaded:false,
      trackList:[],
      trackwasloaded:false,

      GroupNotesFilters:[],
      
      statusList:[],

      leftMenu:[],
      companies: '',
      employeeCode: '',
      providerCode: '',
      provider: '',
      access_token: '',
      IsVip:false,
      IsSpecialCase:false,
      apiurl:'',
      layoutStatus: '',
      isMovile: false,
      m24Format: true,
      dateFormat: '',

      //IncidentDB
      incidentDBDateFrom: null,
      incidentDBDateTo: null,
      incidentDBCategory: {},
      incidentDBReporter: {},
      incidentDBSeverity: {},
      incidentDBRoom: {},
      incidentDBStatus: {},

      //Group Notes
      groupNotesProgramSelected: {},
      // Favorites
      menuItemSelected:{},
      btnFavoriteState: true,
      lang:'',

      // Scheduler Editor vars
      schEdipatientCode: '',
      schEdiActivityId: '',
      // To Show the banner only once, after login for super users
      showOnlyAfterLogin: false,

      permissionEnabledBySetting: false,
      isUseTestResult:false,

      requiredBuildingLocation: false,
      requiredPharmacy: false,
      requiredProgram: false,
      allowMultiProgram: false,
      requiredBuildingLocationList: [],
      requiredPharmacyList: [],
      requiredProgramList: [],
      restrictions: {
        buildingLocation: null,
        pharmacy: null,
        programs: [],
      },
      redirectToRestrictions: false,
      useAIAssist: false
})

const store = new Vuex.Store({

    state: getDefaultState(),
    mutations: {
       RESET_STORE(state) {
          Object.assign(state, getDefaultState());
      },
      SET_LOADING(state, value) {
        state.loading = value
      },
      setCompanies (state,value) { state.companies = value },
      setEmployeeCode (state,value) { state.employeeCode = value },
      setProviderCode (state,value) { state.providerCode = value },
      setProvider (state,value) { state.provider = value },
      setAccessToken (state,value) { state.access_token = value },
      setVip (state,value) { state.IsVip = value },
      setSpecialCase (state,value) { state.IsSpecialCase = value },      
      setApiUrl (state,value) { state.apiurl = value },
      setlayoutStatus (state,value) { state.layoutStatus = value },
      setMovile (state,value) { state.isMovile = value },
      setClockTime (state,value) { state.m24Format = value },
      setDateFormat (state,value) { state.dateFormat = value },
      setLanguage (state,value) { state.lang = value },
      // To Show the banner only once, after login for super users  
      setShowOnlyAfterLogin(state,value) { state.showOnlyAfterLogin = value },
      
      //EHR visibility of the components


      setUseLetters(state,value) { state.isUseLetters = value },
      setUseMars(state,value) { state.isUseMars = value },
      setUseDrugInboxFill (state,value) { state.isUseDrugInboxFill = value },
      setUseDrugInboxAllergies (state,value) { state.isUseDrugInboxAllergies = value },
      setUseDrugInboxFormularyStatus (state,value) { state.isUseDrugInboxFormularyStatus = value },      
      setUseDrugInboxDrugInfo (state,value) { state.isUseDrugInboxDrugInfo = value },
      setUseDrugInboxPatientInfo (state,value) { state.isUseDrugInboxPatientInfo = value },
      setUseDrugInboxPharmacyNotes (state,value) { state.isUseDrugInboxPharmacyNotes = value },
      setUseDrugInboxPrescription (state,value) { state.isUseDrugInboxPrescription = value },
      setUseDrugInboxPrintMedLabel (state,value) { state.isUseDrugInboxPrintMedLabel = value },
      setUseDrugInboxPrintMedicationHistory (state,value) { state.isUseDrugInboxPrintMedicationHistory = value },
      setUseDrugInboxReturnedItems (state,value) { state.isUseDrugInboxReturnedItems = value },
      setUseDrugInboxSetToChargeable (state,value) { state.isUseDrugInboxSetToChargeable = value },
      setUseDrugInboxSetToPending (state,value) { state.isUseDrugInboxSetToPending = value },
      setUseDrugInboxSetToUnableToFill (state,value) { state.isUseDrugInboxSetToUnableToFill = value },
      setUseDrugInboxSetToValid (state,value) { state.isUseDrugInboxSetToValid = value },
      setUseDrugInboxUndoFillOrder (state,value) { state.isUseDrugInboxUndoFillOrder = value },
      setUseDrugInboxUndoSetToChargeable (state,value) { state.isUseDrugInboxUndoSetToChargeable = value },
      setUseDrugInboxUndoSetToPending (state,value) { state.isUseDrugInboxUndoSetToPending = value },
      setUseDrugInboxUndoValidated (state,value) { state.isUseDrugInboxUndoValidated = value }, 

      setUseASAM (state,value) { state.isUseASAM = value },
      setUseEPharmacyNewCrop (state,value) { state.isUsepharmacyPatientNewCrop = value },     
      setUsePatientInfo (state,value) { state.isUsePatientInfo = value },
      setUsePatientInsurance (state,value) { state.isUsePatientInsurance = value },
      setUsePatientDocument (state,value) { state.isUsePatientDocument = value },
      setUsePatientContact(state,value) { state.isUsePatientContact = value },
      setUseClinicalNotes (state,value) { state.isUseClinicalNotes = value },
      setUseVitalSign (state,value) { state.isUseVitalSign = value },
      setUsePatientAllergies (state,value) { state.isUsePatientAllergies = value },
      setUsePatientAdmission (state,value) { state.isUsePatientAdmission = value},
      setUseChartReview (state,value) { state.isUseChartReview = value },
      setUseTransfer (state,value) { state.isUseTransfer = value },
      setUseMedications (state,value) { state.isUseMedications = value },
      setUseDischarge (state,value) { state.isUseDischarge = value },
      setUsePatientDiagnosis (state,value) { state.isUsePatientDiagnosis = value },
      setDailyNotes (state,value) { state.isUseDailyNotes = value },
      setLogNotes (state,value) { state.isUseLogNotes = value },
      setCompleteDraft (state,value) { state.isUseCompleteDraft = value },
      setSchedulerClinical (state,value) { state.isUseSchedulerClinical = value },
      setAppointments (state,value) { state.isAppointments = value },
      setTreatmentPlanClinical (state,value) { state.isUseTreatmentPlanClinical = value },
      setUsePatientSpecialPr (state,value) { state.isUsePatientSpecialPr = value },
      setUsePatientMarsAlert (state,value) { state.isUsePatientMarsAlert = value },
      setUsePatientAlerts (state,value) { state.isUsePatientAlerts = value },
      setUsePatientActivities (state,value) { state.isUsePatientActivities = value },
      setUsePatientClaims (state,value) { state.isUsePatientClaims = value },
      SetPhysiciansOrder (state,value) { state.isPhysiciansOrder = value },

      
      //EHR Read-only of the components


      setLettersEHRReadOnly (state,value) { state.isLettersEHRReadOnly = value },
      setDrugInboxFillEHRReadOnly (state,value) { state.isDrugInboxFillEHRReadOnly = value },
      setDrugInboxAllergiesEHRReadOnly (state,value) { state.isDrugInboxAllergiesEHRReadOnly = value },
      setDrugInboxFormularyStatusEHRReadOnly (state,value) { state.isDrugInboxFormularyStatusEHRReadOnly = value },      
      setDrugInboxDrugInfoEHRReadOnly (state,value) { state.isDrugInboxDrugInfoEHRReadOnly = value },
      setDrugInboxPatientInfoEHRReadOnly (state,value) { state.isDrugInboxPatientInfoEHRReadOnly = value },
      setDrugInboxPharmacyNotesEHRReadOnly (state,value) { state.isDrugInboxPharmacyNotesEHRReadOnly = value },
      setDrugInboxPrescriptionEHRReadOnly (state,value) { state.isDrugInboxPrescriptionEHRReadOnly = value },
      setDrugInboxPrintMedLabelEHRReadOnly (state,value) { state.isDrugInboxPrintMedLabelEHRReadOnly = value },
      setDrugInboxPrintMedicationHistoryEHRReadOnly (state,value) { state.isDrugInboxPrintMedicationHistoryEHRReadOnly = value },
      setDrugInboxReturnedItemsEHRReadOnly (state,value) { state.isDrugInboxReturnedItemsEHRReadOnly = value },
      setDrugInboxSetToChargeableEHRReadOnly (state,value) { state.isDrugInboxSetToChargeableEHRReadOnly = value },
      setDrugInboxSetToPendingEHRReadOnly (state,value) { state.isDrugInboxSetToPendingEHRReadOnly = value },
      setDrugInboxSetToUnableToFillEHRReadOnly (state,value) { state.isDrugInboxSetToUnableToFillEHRReadOnly = value },
      setDrugInboxSetToValidEHRReadOnly (state,value) { state.isDrugInboxSetToValidEHRReadOnly = value }, 
      setDrugInboxUndoFillOrderEHRReadOnly (state,value) { state.isDrugInboxUndoFillOderEHRReadOnly = value },
      setDrugInboxUndoSetToChargeableEHRReadOnly (state,value) { state.isDrugInboxUndoSetToChargeableEHRReadOnly = value },
      setDrugInboxUndoSetToPendingEHRReadOnly (state,value) { state.isDrugInboxUndoSetToPendingEHRReadOnly = value },
      setDrugInboxUndoValidatedEHRReadOnly (state,value) { state.isDrugInboxUndoValidatedEHRReadOnly= value },   


      setASAMEHRReadOnly (state,value) { state.isASAMEHRReadOnly = value },
      setPatientInfoEHRReadOnly (state,value) { state.isPatientInfoEHRReadOnly = value },
      setPatientInsuranceEHRReadOnly (state,value) { state.isPatientInsuranceEHRReadOnly = value },
      setPatientContactsEHRReadOnly (state,value) { state.isPatientContactsEHRReadOnly = value },
      setClinicalNotesEHRReadOnly (state,value) { state.isClinicalNotesEHRReadOnly = value },
      setVitalSignEHRReadOnly (state,value) { state.isVitalSignEHRReadOnly = value },
      setPatientAllergiesEHRReadOnly (state,value) { state.isPatientAllergiesEHRReadOnly = value },
      setPatientAdmissionEHRReadOnly (state,value) { state.isPatientAdmissionEHRReadOnly = value },
      setClinicalTransferEHRReadOnly (state,value) { state.isClinicalTransferEHRReadOnly = value },
      setClinicalMedicationsEHRReadOnly (state,value) { state.isClinicalMedicationsEHRReadOnly= value },
      setClinicalDischargeEHRReadOnly (state,value) { state.isClinicalDischargeEHRReadOnly = value },
      setPatientDiagnosisEHRReadOnly (state,value) { state.isPatientDiagnosisEHRReadOnly = value },
      setDailyNotesEHRReadOnly (state,value) { state.isDailyNotesEHRReadOnly = value },
      setPatientDocumentEHRReadOnly (state,value) { state.isPatientDocumentEHRReadOnly = value },
      setLogNotesEHRReadOnly (state,value) { state.isLogNotesEHRReadOnly = value },
      setSchedulerClinicalEHRReadOnly (state,value) { state.isSchedulerClinicalEHRReadOnly = value },
      setAppointmentsEHRReadOnly (state,value) { state.isAppointmentsEHRReadOnly = value },
      setTreatmentPlanEHRReadOnly (state,value) { state.isTreatmentPlanClinicalEHRReadOnly = value },
      setEPrescribingEHRReadOnly (state,value) { state.isEPrescribingClinicalEHRReadOnly = value },
      setMarsEHRReadOnly (state,value) { state.isMarsEHRReadOnly = value },
      setTarsEHRReadOnly (state,value) { state.isTarsEHRReadOnly = value },
      setPatientSpecialPrEHRReadOnly (state,value) { state.isPatientSpecialPrEHRReadOnly = value },
      setPatientMarsAlertEHRReadOnly (state,value) { state.isPatientMarsAlertEHRReadOnly = value },
      setPatientAlertsEHRReadOnly (state,value) { state.isPatientAlertsEHRReadOnly = value },
      setPatientActivitiesEHRReadOnly (state,value) { state.isPatientActivitiesEHRReadOnly = value },
      setPatientClaimsEHRReadOnly (state,value) { state.isPatientClaimsEHRReadOnly = value },
      setPhysiciansOrderEHRReadOnly (state,value) { state.isPhysiciansOrderEHRReadOnly = value },
      setUseAIAssist (state, value) { state.useAIAssist = value },

      //IncidentDB
      setIncidentDBDateFrom (state,value) { state.incidentDBDateFrom = value },
      setIncidentDBDateTo (state,value) { state.incidentDBDateTo = value },
      setIncidentDBCategory (state,value) { state.incidentDBCategory = value },
      setIncidentDBReporter (state,value) { state.incidentDBReporter = value },
      setIncidentDBSeverity (state,value) { state.incidentDBSeverity = value },
      setIncidentDBRoom (state,value) { state.incidentDBRoom = value },
      setIncidentDBStatus (state,value) { state.incidentDBStatus = value },

      setWrotePasswordMars(state,value) { state.alreadyWrotePassword = value },
      setWrotePasswordNotes(state,value) { state.alreadyWrotePasswordNotes = value },
      setWrotePasswordCosignerNotes(state,value) { state.alreadyWrotePasswordCosignerNotes = value },  
      setWrotePasswordTars(state,value) { state.alreadyWrotePasswordTars = value },    

      setGroupNotesFilters(state,value){      
        state.GroupNotesFilters = value
      },
      setGroupNotesFiltersInitialize(state,value){      
        state.GroupNotesFilters = value;
      },

      // Country
      initCountryList(state){
        state.CountryList = []
      },
      setCountryList (state,value) { 
        state.CountryList.push(value)
      },
      setcountrywasloaded(state,value){
        state.countrywasloaded = value;
      },


      // Region
      initRegionList(state){
        state.RegionList = []
      },
      setRegionList (state,value) { 
        state.RegionList.push(value)
      },
      setregionwasloaded(state,value){
        state.regionwasloaded = value;
      },

      // Area
      initAreaList(state){
        state.AreaList = []
      },
      setAreaList(state,value) { 
        state.AreaList.push(value)
      },
      setareawasloaded(state,value){
        state.areawasloaded = value;
      },



        // Cities
      initCitiesList(state){
        state.CitiesList = []
      },
      setCitiesList(state,value) { 
        state.CitiesList.push(value)
      },
      setcitieswasloaded(state,value){
        state.citieswasloaded = value;
      },

        // MdCountries
      initMdCountriesList(state){
        state.MdCountriesList = []
      },
      setMdCountriesList(state,value) { 
        state.MdCountriesList.push(value)
      },
      setmdCountrieswasloaded(state,value){
        state.mdCountrieswasloaded = value;
      },







      //Ethnicity List
      initEthnicityList(state){
        state.ethnicityList = []
      },
      setEthnicityList (state,value) { 
        state.ethnicityList.push(value)
      },

      setethnicitywasloaded(state,value){
        state.ethnicitywasloaded = value;
      },
      //Gender List
      initGenderList(state){
        state.genderList = []
      },
      setGenderList (state,value) { 
        state.genderList.push(value)
      },
      setGenderwasloaded(state,value){
        state.genderwasloaded = value;
      },
      //BranchLocation
       initBranchLocationList(state){
        state.branchlocationsList = []
      },
      setBranchLocationList (state,value) { 
        state.branchlocationsList.push(value)
      },
      setBranchLocationwasloaded(state,value){
        state.branchlocationwasloaded = value;
      },

      //Race List
      initRaceList(state){
        state.raceList = []
      },
      setRaceList (state,value) { 
        state.raceList.push(value)
      },     
      setracewasloaded(state,value){
        state.racewasloaded = value;
      },
      //Eye Color List
      initEyeColorList(state){
        state.eyeColorList = []
      },
      setEyeColorList (state,value) { 
        state.eyeColorList.push(value)
      },     
      seteyeColorwasloaded(state,value){
        state.eyeColorwasloaded = value;
      },
      //Hair Color List
      initHairColorList(state){
        state.hairColorList = []
      },
      setHairColorList (state,value) { 
        state.hairColorList.push(value)
      },      
      sethairColorwasloaded(state,value){
        state.hairColorwasloaded = value;
      },
      //Comm Preference List
      initCommPreferenceList(state){
        state.commPreferenceList = []
      },
      setCommPreferenceList (state,value) { 
        state.commPreferenceList.push(value)
      },      
      setcommPreferencewasloaded(state,value){
        state.commPreferencewasloaded = value;
      },
      //Family Income List
      initFamilyIncomeList(state){
        state.familyIncomeList = []
      },
      setFamilyIncomeList (state,value) { 
        state.familyIncomeList.push(value)
      },
      //familyIncomewasloaded
      setfamilyIncomewasloaded(state,value){
        state.familyIncomewasloaded = value;
      },
      //Personal Income List
      initPersonalIncomeList(state){
        state.personalIncomeList = []
      },
      setPersonalIncomeList (state,value) { 
        state.personalIncomeList.push(value)
      },
      //
      setpersonalIncomewasloaded(state,value){
        state.personalIncomewasloaded = value;
      },
      //Major Language List
      initMajorLanguageList(state){
        state.majorLanguageList = []
      },
      setMajorLanguageList (state,value) { 
        state.majorLanguageList.push(value)
      },      
      setmajorLanguagewasloaded(state,value){
        state.majorLanguagewasloaded = value;
      },
      //Major Language Ability List
      initMajorLanguageAbilityList(state){
        state.majorLanguageAbilityList = []
      },
      setMajorLanguageAbilityList (state,value) { 
        state.majorLanguageAbilityList.push(value)
      },
      //
      setmajorLanguageAbilitywasloaded(state,value){
        state.majorLanguageAbilitywasloaded = value;
      },
      //Major Religion List
      initMajorReligionList(state){
        state.majorReligionList = []
      },
      setMajorReligionList (state,value) { 
        state.majorReligionList.push(value)
      },     
      setmajorReligionwasloaded(state,value){
        state.majorReligionwasloaded = value;
      },
      //Disability List
      initDisabilityList(state){
        state.disabilityList = []
      },
      setDisabilityList (state,value) { 
        state.disabilityList.push(value)
      },
      //
      setdisabilitywasloaded(state,value){
        state.disabilitywasloaded = value;
      },
      //Legal Status List
      initLegalStatusList(state){
        state.legalStatusList = []
      },
      setLegalStatusList (state,value) { 
        state.legalStatusList.push(value)
      },
      //
      setlegalStatuswasloaded(state,value){
        state.legalStatuswasloaded = value;
      },
      //Education Status List
      initEducationStatusList(state){
        state.educationStatusList = []
      },
      setEducationStatusList (state,value) { 
        state.educationStatusList.push(value)
      },
      //
      seteducationStatuswasloaded(state,value){
        state.educationStatuswasloaded = value;
      },
      setProviderList (state, value){
        state.ProvidersList = value;
      },
      setReasonDataSource (state,value) { 
        state.reasonDataSource = value 
      },

      setclinicalDashboardProgramsSelected(state,value){
        state.clinicalDashboardProgramsSelected = value;
      },

      setItemListGroupNotes(state,list){       
        state.itemListGroupNotes = list;
      },

      setItemListCNContainer(state,list){
        state.itemListCNContainer = list;
      },


      // Admission       
      initSourcesList(state){
        state.sourceList = []
      },
      setSourceList(state,value){ 
        state.sourceList.push(value)
      },      
      setsourcewasloaded(state,value){
        state.sourcewasloaded = value;
      },

      initTypeList(state){
        state.typeList = []
      },
      setTypeList(state,value){ 
        state.typeList.push(value)
      },      
      settypewasloaded(state,value){
        state.typewasloaded = value;
      },

      initClassList(state){
        state.classList = []
      },
      setClassList(state,value){ 
        state.classList.push(value)
      },    
      setclasswasloaded(state,value){
        state.classwasloaded = value;
      },

      initVocationalEffortList(state){
        state.vocationalEffortList = []
      },
      setVocationalEffortList(state,value){ 
        state.vocationalEffortList.push(value)
      },      
      setvocationalEffortwasloaded(state,value){
        state.vocationalEffortwasloaded = value;
      },

      initVocationalCategoryList(state){
        state.vocationalCategoryList = []
      },
      setVocationalCategoryList(state,value){ 
        state.vocationalCategoryList.push(value)
      },      
      setvocationalCategorywasloaded(state,value){
        state.vocationalCategorywasloaded = value;
      },
    
     initFromList(state){
        state.fromList = []
      },
      setFromList(state,value){ 
        state.fromList.push(value)
      },      
      setfromwasloaded(state,value){
        state.fromwasloaded = value;
      },
      
      initLivingWithList(state){
        state.livingWithList = []
      },
      setLivingWithList(state,value){ 
        state.livingWithList.push(value)
      },
      //
      setlivingWithwasloaded(state,value){
        state.livingWithwasloaded = value;
      },
     
      initStatusList(state){
        state.statusList = []
      },
      setStatusList(state,value){ 
        state.statusList.push(value)
      },
     
      initAssessmentList(state){
        state.assessmentList = []
      },
      setAssessmentList(state,value){ 
        state.assessmentList.push(value)
      }, 
      setassessmentwasloaded(state,value){
        state.assessmentwasloaded = value;
      },

      initTrackList(state){
        state.trackList = []
      },
      setTrackList(state,value){ 
        state.trackList.push(value)
      },  
      settrackwasloaded(state,value){
        state.trackwasloaded = value;
      },      
      initReferralsList(state){
        state.referralsList = []
      },
      setReferralsList(state,value){ 
        state.referralsList.push(value)
      },     
      setreferralswasloaded(state,value){
        state.referralswasloaded = value;
      },


      initLeftMenu(state){
        state.leftMenu = []
      },
      setLeftMenu(state,value){ 
        state.leftMenu = value;
      },

      setgroupNotesProgramSelected(state,value){
        state.groupNotesProgramSelected = value;
      },

      // Favorites
      setMenuItemSelected(state,value){      
        state.menuItemSelected = value;
      },
          
      setBtnFavoriteState(state,value){
        state.btnFavoriteState = value;
      },

      //Scheduler Editor Sets
      setSchEdipatientCode(state,value){
        state.schEdipatientCode = value;
      },
      setSchEdiActivityId(state,value){
        state.schEdiActivityId = value;
      },

      setPermissionEnabledBySetting(state, value) {
        state.permissionEnabledBySetting = value;
      },

      //User restrictions
      setRequiredBuildingLocation(state, value) {
        state.requiredBuildingLocation = value;
      },

      setRequiredBuildingLocationList(state, value) {
        state.requiredBuildingLocationList = value;
      },

      setRequiredPharmacy(state, value) {
        state.requiredPharmacy = value;
      },

      setRequiredPharmacyList(state, value) {
        state.requiredPharmacyList = value;
      },

      setRequiredProgram(state, value) {
        state.requiredProgram = value;
      },

      setRequiredProgramList(state, value) {
        state.requiredProgramList = value;
      },

      setAllowMultiProgram(state, value) {
        state.allowMultiProgram = value;
      },

      setRestrictions(state, value) {
        state.restrictions = value;
        state.redirectToRestrictions = false;
      },

      setRedirectToRestrictions(state, value) {
        state.redirectToRestrictions = value;
      },

      setUseTestResult (state,value) { state.isUseTestResult = value },
    },

    getters: {
      // Verifica si el usuario tiene permiso para una ruta y acción específica
      hasPermission: (state) => (path, permission) => {
        if (permission === undefined || permission === null) {
          return true;
        }

        const {
          action: actionKey = '',
          codeKey = `${path.trim()}/`,
          ehrFeature: ehrFeatureKey = ''
        } = {
          ...permission,
          ehrFeature: !Utils.isNullOrEmptyString(permission.ehrFeature) ? permission.ehrFeature.trim() : ''
        };       

        if (!Utils.isNullOrEmptyString(ehrFeatureKey)) {
          const ehrFeature = state[ehrFeatureKey];
          if (ehrFeature !== null && ehrFeature !== undefined && !ehrFeature) {
            return false;
          }
        }

        if (!state.permissionEnabledBySetting) {
          return true; // si los permisos están deshabilitados, todo pasa
        }        

        const capitalizeActionKey = Utils.capitalizeFirstLetter(actionKey);
        const actionToCheckPermission = `roleCan${capitalizeActionKey}`;
        if (!['roleCanView', 'roleCanAdd', 'roleCanEdit', 'roleCanDelete'].some(role => role === actionToCheckPermission)) {
          return true;
        }       

        const searchMenu = (items) => {
          for (const item of items) {
            // Solo valida si es menu o submenu y coincide el href
            if (item.href && (item.type === "menu" || item.type === "submenu")) {
              const itemPath = `${item.href.trim()}/`;

              if (codeKey.includes(itemPath)) {
                let result = null;
                switch (capitalizeActionKey) {
                  case 'View': 
                    result = item[actionToCheckPermission] === true;
                    break;
                  case 'Add':
                  case 'Edit':
                  case 'Delete':
                    result = item[`has${capitalizeActionKey}`] === true && item[actionToCheckPermission] === true;
                    break;
                }
                
                return result;
              }
            }

            if (item.child && item.child.length > 0) {
              const found = searchMenu(item.child);
              
              if (found !== null) {
                return found;
              }
            }
          }
          
          return null;
        };

        const result = searchMenu(state.leftMenu);
        return result === true;
      }
    },

    plugins: [
      createPersistedState({
        storage: {
          getItem: (key) => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: (key) => ls.remove(key),
        },
      }),
    ],
  })

  export default store